var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/display-name.tsx";
import * as React from 'react';
import HoverRefWrapper from 'soapbox/components/hover_ref_wrapper';
import { useSoapboxConfig } from 'soapbox/hooks';
import { getAcct } from '../utils/accounts';
import Icon from './icon';
import RelativeTimestamp from './relative_timestamp';
import VerificationBadge from './verification_badge';
const DisplayName = ({
  account,
  children,
  withDate = false
}) => {
  const {
    displayFqn = false
  } = useSoapboxConfig();
  const {
    created_at: createdAt,
    verified
  } = account;
  const joinedAt = createdAt ? /*#__PURE__*/React.createElement("div", {
    className: "account__joined-at",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    src: require('@tabler/icons/clock.svg'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(RelativeTimestamp, {
    timestamp: createdAt,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 7
    }
  })) : null;
  const displayName = /*#__PURE__*/React.createElement("span", {
    className: "display-name__name",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("bdi", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("strong", {
    className: "display-name__html",
    dangerouslySetInnerHTML: {
      __html: account.get('display_name_html')
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 12
    }
  })), verified && /*#__PURE__*/React.createElement(VerificationBadge, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 20
    }
  }), withDate && joinedAt);
  const suffix = /*#__PURE__*/React.createElement("span", {
    className: "display-name__account",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 19
    }
  }, "@", getAcct(account, displayFqn));
  return /*#__PURE__*/React.createElement("span", {
    className: "display-name",
    "data-testid": "display-name",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(HoverRefWrapper, {
    accountId: account.get('id'),
    inline: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 7
    }
  }, displayName), suffix, children);
};
export default DisplayName;